// Formatting for an event's venue wall-clock times.
//
// startTime/endTime arrive from the CMS as 'HH:mm' 24-hour strings (e.g.
// "18:00"). They are deliberately NOT Date objects: eventDate is a date-only
// midnight-UTC value, and folding a time into it would reintroduce the
// timezone off-by-one that showed viewers abroad the previous day. A plain
// string means "6:00 PM at the venue" to every visitor, wherever they are.
//
// Every function tolerates empty/malformed input by returning null, so callers
// can render the date alone exactly as they did before times existed.

const CLOCK_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;

// "18:00" -> "6:00 PM"; null for anything that is not a valid HH:mm.
export function formatClockTime(value) {
  const match = CLOCK_PATTERN.exec((value || "").trim());
  if (!match) return null;

  const hours = Number(match[1]);
  const minutes = match[2];
  const period = hours < 12 ? "AM" : "PM";
  // 00:xx renders as 12:xx AM, and 12:xx stays 12:xx PM.
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;

  return `${hour12}:${minutes} ${period}`;
}

// Both set -> "6:00 PM – 8:30 PM"; start only -> "6:00 PM onwards";
// end only (unusual, but don't silently drop it) -> "Until 8:30 PM".
// Returns null when neither is set so callers can skip the whole element.
export function formatTimeRange(startTime, endTime) {
  const start = formatClockTime(startTime);
  const end = formatClockTime(endTime);

  if (start && end) return `${start} – ${end}`;
  if (start) return `${start} onwards`;
  if (end) return `Until ${end}`;
  return null;
}
